import { useScreenVariant } from "../../branding/useScreenVariant";
import { ScreenVariant } from "../../branding/selectScreen";
import { BrandScope } from "../../branding/BrandScope";

import ForgotPasswordDefault from "./ForgotPasswordDefault";
import ForgotPasswordNotPortal from "./ForgotPasswordNotPortal";
import ForgotPasswordTrading from "./ForgotPasswordTrading";
import ForgotPasswordBranded from "./ForgotPasswordBranded";

function ForgotPassword() {
  const { variant, brand } = useScreenVariant();

  switch (variant) {
    case ScreenVariant.NOT_PORTAL:
      return <ForgotPasswordNotPortal />;
    case ScreenVariant.TRADING:
      return <ForgotPasswordTrading />;
    case ScreenVariant.BRANDED:
      return (
        <BrandScope brand={brand}>
          <ForgotPasswordBranded />
        </BrandScope>
      );
    default:
      return <ForgotPasswordDefault />;
  }
}

export default ForgotPassword;
